export default "<p>\n  patients works!\n</p>\n"